import React from "react";
import About from "./About";
import Contact from "./Contact";
import Home from "./Home";
import Services from "./Services";
import {BrowserRouter, Routes, Route} from "react-router-dom";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Error from "./Components/Error";
import { ThemeProvider } from "styled-components";
import { GlobalStyle } from "./GlobalStyle";
import GoToTop from "./Components/GoToTop";
import Login from "./Login";
import Register from "./Register";

const App =() =>{

  const theme ={
    colors: {
      heading: 'rgb(24 24 29)',
      text: 'rgb(24 24 29)',
      white: '#fff',
      black: '#212529', 
      helper: '#8490ff', 
      bg: 'rgb(249 249 255)',
      footer_bg: '#0a1435',
      btn: 'rgba(98, 84,243, 0.5)',
      hr: '#ffffff',
      gradient: 
      "linear-gradient(0 deg, rgb(132 144 355) 0%, rgb(98 189 252) 100%)",
      shadow:
      'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 5px',
      shadowSupport: 'rgba(0, 0, 0, 0.16) 0px 1px 4px',

    },

    media:{mobile:"768px", tab:"998px"},
  
  }
  return(
    <ThemeProvider theme={theme}>
    <GlobalStyle/>
    
    <BrowserRouter>
      <Header/>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/about" element={<About/>}/>
        <Route path="/contact" element={<Contact/>}/>
        <Route path="/services" element={<Services/>}/>
        <Route path ='/login' element={<Login/>} />
        <Route path ='/register' element={<Register/>} />
        <Route path="*" element={<Error/>}/>
      </Routes>
      <GoToTop/>
      <Footer/>
    </BrowserRouter>
     
    </ThemeProvider>
  );
}

export default App;